import React, { useState, useEffect, useRef } from "react"
import { Button, Card, CardBody, CardTitle } from "reactstrap"
import { Formik, Form } from "lib/formik"
import Select from "react-select"
import { useDispatch, useSelector } from "react-redux"
import { showAlert } from "store/reducers/alertReducer"
import { post } from "helpers/api_helper"
import { QR_CODE_GENERATE, SAVE_DYNAMIC_LINK } from "helpers/url_helper"
import { useTranslation } from "react-i18next"
import Switch from "components/Shared/Switch"
import { useNavigate } from "react-router-dom"
import isPermissionEnabled from "common/isPermissionEnabled"

const GenerateQRCode = () => {
  const { t } = useTranslation()

  const initialValues = {
    type: {
      label: t("Gift Cards List View"),
      value: "GIFT_CARDS_LIST_VIEW",
    },
  }

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { userRole, accountType } = useSelector(state => state.Login)
  const [link, setLink] = useState(null)

  const copyToClipboard = data => {
    const dataString = JSON.stringify(data, null, 2)

    const textarea = document.createElement("textarea")
    textarea.value = dataString
    textarea.setAttribute("readonly", "")
    textarea.style.position = "absolute"
    textarea.style.left = "-9999px"
    document.body.appendChild(textarea)

    try {
      textarea.select()
      const successful = document.execCommand("copy")
      if (successful) {
        dispatch(
          showAlert({ text: t("Data copied to clipboard!"), type: "success" })
        )
      } else {
        dispatch(showAlert({ text: t("Failed to copy"), type: "failed" }))
      }
    } catch (err) {
      dispatch(showAlert({ text: t("Failed to copy"), type: "failed" }))
    } finally {
      document.body.removeChild(textarea)
    }
  }

  const [usersPermissions, setUsersPermissions] = useState({
    list: null,
    add: null,
  })
  // FIRST CHECK PERMISSION, IF DOES'T HAVE THEN REDIRECT TO DASHBOARD
  useEffect(() => {
    const isPermissionList = isPermissionEnabled(
      userRole,
      39,
      "dynamic_link_1",
      accountType
    )

    const isPermissionAdd = isPermissionEnabled(
      userRole,
      39,
      "dynamic_link_2",
      accountType
    )
    if (!isPermissionList) {
      navigate("/dashboard")
    }
    setUsersPermissions({
      list: isPermissionList,
      add: isPermissionAdd,
    })
  }, [userRole])
  // Handle form submission
  const handleOnSubmit = async (values, { resetForm }) => {
    const { type } = values

    const updatedType = type.value

    const payload = {
      targetObj: {
        type: updatedType,
      },
    }

    const response = await post(QR_CODE_GENERATE, payload)

    if (response?.statusCode === 200 && response?.status) {
      const { link } = response?.data || {}
      setLink(link)
      dispatch(showAlert({ text: response?.msg, type: "success" }))
    } else {
      dispatch(showAlert({ text: response?.msg, type: "error" }))
    }
  }

  // Handle copy to clipboard
  const handleCopyUrl = () => {
    copyToClipboard(link)
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-6">
            <Card>
              <CardBody>
                <CardTitle>{t("Gift Card Deep Link")}</CardTitle>
                <Formik initialValues={initialValues} onSubmit={handleOnSubmit}>
                  {({ values, setFieldValue, isSubmitting }) => (
                    <Form>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="mt-3">
                            <label htmlFor="type">{t("Select Type")}</label>
                            <Select
                              value={values.type}
                              onChange={item => setFieldValue("type", item)}
                              options={[
                                {
                                  label: t("Gift Cards List View"),
                                  value: "GIFT_CARDS_LIST_VIEW",
                                },
                              ]}
                              placeholder={t("Select Type")}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-12">
                          {usersPermissions.add && (
                          <Button
                            type="submit"
                            color="success"
                            className="d-block ms-auto"
                            disabled={isSubmitting || !values.type}
                          >
                            {t("Gift Card Deep Link")}
                          </Button>
                          )}
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </CardBody>
            </Card>
          </div>

          <div className="col-lg-6">
            <Card>
              <CardBody>
                <div>
                  <h3 className="text-black text-center fz-bold mt-2">
                    {t("Half Million")}
                  </h3>

                  <div className="d-flex">
                    {link ? (
                      <Button
                        color="primary"
                        className="mx-auto d-block mt-3"
                        onClick={handleCopyUrl}
                      >
                        {t("Copy URL")}
                      </Button>
                    ) : (
                      <p className="text-center w-100 my-3 fs-5">{t("No Link Generated")}</p>
                    )}
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    </div>
  )
}

export default GenerateQRCode
